module.exports = __webpack_public_path__ + "img/ai_search.505c330.svg";